/* eslint-disable */
export function makeBackofficeUrls(backofficeUrlBase) {
    const boServer = backofficeUrlBase + '/backoffice';
    return {
        package: {
            getListPackage: boServer + '/packages/pagination',
            getPackagePromotion: boServer + '/packages/promotion',
            getPackage: boServer + '/packages/${package_id}',
            getPackageByChargeMode: boServer + '/packages/charge-mode/${mode}/enabled',
            postCreatePackage: boServer + '/packages',
            patchUpdatePackage: boServer + '/packages',
            getPackageInfoList: boServer + '/packages/info',
            postAddPrivilege: boServer + '/company-privilege',
            getCompanyPrivilege: boServer + '/company-privilege/company/${company_id}',
            getCompanyCreditsPrivileges: boServer + '/company-privilege/credits/company/${company_id}',
            postAddCreditsPrivilege: boServer + '/company-privilege/credits',
            putUpdateCreditsPrivilege: boServer + '/company-privilege/credits',
            putCreditsPrivilegeEnabled: boServer + '/company-privilege/credits/enabled',
            putCompanyPrivilegeExcludeFeatures: boServer + '/company-privilege/exclude-features',
            postBatchAssignCredits: boServer + '/company-privilege/credits/assignation',
            postCompanyPrivilegeAssignation: boServer + '/company-privilege/assignation',
            putUpdateCompanyPrivilege: boServer + '/company-privilege',
            patchModifyCompanyPrivilege: boServer + '/company-privilege',
            postBatchAssignUsers: boServer + '/company-privilege/assignation/batch',
            patchEnablePrivilege: boServer + '/company-privilege-contract/${privilege_id}/enable',
            patchDisablePrivilege: boServer + '/company-privilege-contract/${privilege_id}/disable',
            // 套餐容量配置
            getPackageCapacityConfig: boServer + '/contract-capacity-config/package/${package_id}',
            // Credits 配置
            getCompanyCreditsConfig: boServer + '/company-credits/${company_id}/config',
            putCompanyCreditsConfig: boServer + '/company-credits/config',
        },
        companyOrder: {
            getOrders: boServer + '/orders/company/${company_id}',
            getBehaviorOrders: boServer + '/behavior/company/order/${company_id}',
            getOrderDetail: boServer + '/orders/${order_id}',
            postOrderAdd: boServer + '/orders',
            putOrderEdit: boServer + '/orders',
            patchOrderEnable: boServer + '/orders/${order_id}/enable',
            patchOrderDisable: boServer + '/orders/${order_id}/disable',
            patchCompanyPrivilegeContractDelete: boServer + '/company-privilege-contract/${privilege_contract_id}/disable',
            patchCompanyCapacityContractAllDelete: boServer + '/company-capacity-contract/${order_id}/capacities/disable',
            getOrderContractExisted: boServer + '/orders/contract/contract-number',
            postOrderEditCheck: boServer + '/orders/update-order/check',
            postOrderCheck: boServer + '/orders/check',
        },
        account: {
            getCurrentUser: boServer + '/accounts/current-user-account-info',
            exportUsers: boServer + '/behavior-export/export-users',
            postAddAccountPrivilege: boServer + '/account-privilege',
            deleteAccountPrivilege: boServer + '/account-privilege/${account_id}/${company_privilege_id}',
            /**
             * 添加试用
             */
            postAccountPrivilegeTrial: boServer + '/tenant-user-privileges/add-trial',
            postAccountPrivilegeTrialCheck: boServer + '/tenant-user-privileges/add-trial-pre-check',
            postAccountPrivilegeTrialBatchCheck: boServer + '/tenant-user-privileges/add-trial-tenant-pre-check',
            postAccountPrivilegeTrialBatch: boServer + '/tenant-user-privileges/add-trial-tenant',
            // 用户上添加单个试用
            deleteAccountPrivilegeTrial: boServer + '/account-privilege/trial/${account_id}/${privilege_id}',
            getTrialDaysLimitation: boServer + '/account-privilege/trial/days-limitation',
            // 获取用户列表
            listAccounts: boServer + '/accounts/pagination',
            getAccountBatchInfoSummary: boServer + '/proxy/behavior/account/batch/info/summary',
            getCompanyFakeActiveUsers: boServer + '/accounts/company/${company_id}/fake-active',
            patchAccountsBatchEdit: boServer + '/accounts/batch/edit',
            patchAccountActivation: boServer + '/accounts/activation',
            patchUpdatePassword: boServer + '/accounts/${account_id}/password',
            getSimpleAccountInfoView: boServer + '/accounts/account-basic',
            patchAccountUnlock: boServer + '/accounts/${account_id}/unlock',
            patchAccountEdit: boServer + '/accounts/edit',
            postUserRoleBatchEdit: boServer + '/accounts/user-role/batch/edit',
            postIPRestrictCheck: boServer + '/accounts/ip-restrict/batch/edit/check',
            postIPRestrictBatchEdit: boServer + '/tenant-users/batch/ip-restrict',
            postFakeActivecheck: boServer + '/accounts/fake-active/batch/edit/check',
            postSendEmailBatch: boServer + '/accounts/batch/send/email',
            getAccountSendEmail: boServer + '/accounts/send/email/${account_id}',
            getAccountDetail: boServer + '/accounts/${account_id}',
            getAccountProducts: boServer + '/accounts/products',
            getIdentifyToken: boServer + '/accounts/identify-token',
            postRelieveSsoBinding: boServer + '/tenant-users/unbind/sso',
            postRelieveSocialBinding: boServer + '/accounts/relieve/social/binding',
            deleteInnoCloudBinding: boServer + '/innocloud-user/user',
            deleteMfaUnbind: boServer + '/accounts/${userId}/mfa/unbind',
            // 试用注册的用户信息
            postAccountBind: boServer + '/account-binding',
            postAccountAudit: boServer + '/account-dingtalk/audit',
            /**
             * 用户 设置
             */
            putAccountsSetting: boServer + '/accounts/setting',
            /** 用户产品权限列表 */
            getAccountProductView: boServer + '/accounts/${account_id}/product/view',
            /** 用户系统限制 */
            getSystemLimit: boServer + '/accounts/system/limit/${account_id}',
            patchSystemLimit: boServer + '/accounts/system/limit/edit',
            postBeisenAccountByEmails: boServer + '/accounts/bei-sen',
            getAccountBasic: boServer + '/accounts/account-basic',
            getAccountTenants: boServer + '/accounts/tenants/${account_id}',
            getTenantsUsersBasic: boServer + '/tenant-users/basic',
            getTenantUserView: boServer + '/tenant-users/${userId}/view',
            postTenantUserBatchFakeActive: boServer + '/tenant-users/batch/fake-active',
            postTenantUserBatchDisable: boServer + '/tenant-users/batch/disable',
            postTenantUserBatchJobRole: boServer + '/tenant-users/batch/job-role',
            getTenantUsersPrivilegeView: boServer + '/tenant-users/privilege-view',
            putAccountPrivilegeExcludeFeatures: boServer + '/tenant-users/account-privilege-exclude-features',
            postTenantUsersPagination: boServer + '/tenant-users/pagination',
            getTenantUsersSettingBasic: boServer + '/tenant-users/setting-basic',
            patchAccountsBlock: boServer + '/accounts/block',
            patchAccountsUnblock: boServer + '/accounts/unblock',
            getTenantUsersList: boServer + '/tenant-users/list',
            putTenantUsersIndividual: boServer + '/tenant-users/individual/${tenant_user_id}/${enabled}',
            getLoginHistory: boServer + '/tenant-users/login-history',
        },
        product: {
            getProducts: boServer + '/products',
            getWithUnlockedRoles: boServer + '/products/with-unlocked-roles',
            getFeatureCapacityRoles: boServer + '/products/feature-capacity-roles',
            getRoles: boServer + '/products/roles',
            getProductAllRoles: boServer + '/product/roles/${product_id}/all',
            getClients: boServer + '/clients',
            getClientRoles: boServer + '/clientroles',
            getProductRoles: boServer + '/product/roles/${product_id}',
            getProductResource: boServer + '/resources/product/${product_id}',
            getProductResourceByModule: boServer + '/resources/product/${product_id}/module/${module_type}',
            getProducDataResource: boServer + '/data-resources/product/${product_id}',
            getResourceByRole: boServer + '/resources/role/${role_id}/permission',
            getDataResourceByRole: boServer + '/role-data-resources/role/${role_id}',
            postResourceByRole: boServer + '/product/roles/resource',
            deleteResource: boServer + '/resources/batch',
            postResource: boServer + '/resources',
            getResource: boServer + '/resources/${resource_id}',
            getResourceLan: boServer + '/resources/${resource_id}/lang',
            getResourceApi: boServer + '/apis/${resource_id}',
            postResourceApi: boServer + '/apis',
            postRoleResource: boServer + '/role-resource/importing',
            postBatchRoleResource: boServer + '/product/roles/resource/list',
            postBatchRoleDataResource: boServer + '/role-data-resources/resource',
            // #region 产品角色限制
            productEnableRoleList: boServer + '/product/roles/${product_id}?enabled=true',
            productResouce: boServer + '/resources/product/${product_id}',
            resourcesRoleLimitation: boServer + '/resources/role/${id}/limitation',
            productRolesLimitation: boServer + '/product/roles/limitation',
            getResourcesProductResources: boServer + '/resources/product/${product_id}/resources',
            getResourcesRoleResources: boServer + '/resources/role/${role_id}/resources',
        },
        company: {
            getCompanyInfo: boServer + '/companies/${company_id}',
            getQueryCompanies: boServer + '/companies/solr',
            postCreateCompany: boServer + '/companies',
            getCompanyList: boServer + '/companies/pagination',
            getQueryCompanyProducts: boServer + '/companies/products',
            getCompanyByKeyword: boServer + '/companies/recommend/company/match',
            /** 获取安全设置数据 */
            getCompanySecurity: boServer + '/companies/security/${company_id}',
            patchCompanySetting: boServer + '/companies/${company_id}',
            patchCompanyTrialSecuritySettings: boServer + '/companies/trial/security-settings',
            patchCompanyGeneralSetting: boServer + '/companies/general/${company_id}',
            patchCompanySsoSetting: boServer + '/companies/sso/${company_id}',
            getCompanySSOQueryCompanyId: boServer + '/company/sso/query/companyId',
            postCompanySsoKeepAttribute: boServer + '/company/sso/keep/attribute',
            patchCompanySettingForm: boServer + '/companies/${company_id}/setting',
            getCompanyGrant: boServer + '/companies/grant/${company_id}',
            postCompaniesBatchEdit: boServer + '/companies/paid-type/batch',
            getCompanyCustomizedAuthUrl: boServer + '/companies/customized-auth-url',
            // crm
            getCompanyCrmInfo: boServer + '/companies/crm-name/company',
            getCompanyInfoBySalesforceId: boServer + '/companies/salesforce-id/company',
            getCompanySystemLimit: boServer + '/companies/system/limit/${company_id}',
            patchCompanySystemLimit: boServer + '/companies/system/limit/${company_id}',
            getSalesCSByCompanyId: boServer + '/salesforce-synchronize/sale/company/all',
            getMetaDataChecked: boServer + '/companies/check/metadata/url',
            postCompanyInvitation: boServer + '/companies/sales/invitation',
            postCompanyLoginSettingLoginChannel: boServer + '/company-login-setting/login-channel',
            postCompanyLoginSettingCopywriting: boServer + '/company-login-setting/copywriting',
            // sso jwt ip
            postCompanySsoOaIp: boServer + '/companies/oa/ip/${company_id}',
            getCompanySsoOaIp: boServer + '/companies/oa/ip/${company_id}',
            getCompanyPackageAndProduct: boServer + '/companies/company-package-product/${company_id}',
            patchCompanyJwtLimit: boServer + '/companies/system/jwt-sso-display/${company_id}',
            postCompaniesUnbindUserCarsi: boServer + '/companies/unbind-users-carsi/${company_id}',
            getQrCodeByUrl: boServer + '/qrcode/text',
            getCheckCompanyName: boServer + '/companies/check/company-name',
            getSalesforceCompanyName: boServer + '/salesforce-synchronize/company-name',
            // 客户360
            getCustomerViewCompanyMainProduct: boServer + '/customer-view/company/main-product',
            getCustomerViewCompanyStat: boServer + '/customer-view/company/stat',
            getCustomerViewCompanyAttribute: boServer + '/customer-view/company/attribute',
            getCustomerViewCompanyLicense: boServer + '/customer-view/company/license',
            getCustomerAiReport: boServer + '/customer-ai-report/${company_id}',
            postCustomerAiReportFeedback: boServer + '/customer-ai-report/feedback',
            sseCustomerAiReport: boServer + '/customer-ai-report/${company_id}',
            getCompanyTagPagination: boServer + '/company-tag/pagination',
        },
        companyDataAnalysis: {
            getCompanyDataAnalysis: boServer + '/company-data-analysis/report',
            getCompanyDataAnalysisDetail: boServer + '/company-data-analysis/detail',
            getCompanyDataAnalysisDashboard: boServer + '/company-data-analysis/summary-stat',
            getCompanyDataAnalysisUserPrivileges: boServer + '/company-data-analysis/new-user/user-privileges',
            getCompanyDataAnalysisUserPrivilegesSummary: boServer + '/company-data-analysis/user-usage-summary',
            getCompanyDataAnalysisUsageDownload: boServer + '/company-data-analysis/${report_name}-download',
            getCompanyDataAnalysisKickedOutSummary: boServer + '/company-data-analysis/user-kicked-out-summary',
            getCompanyDataAnalysisKickedOutDownload: boServer + '/company-data-analysis/kicked-out-usage-download',
            postLoginOverviewUsageDownload: boServer + '/company-data-analysis/login-overview-usage-download',
            postCompanyEurekaUsageDownload: boServer + '/company-data-analysis/eureka-company-usage-download',
        },
        companyConnect: {
            getConnectPermissions: boServer + '/openapi-customer360/orders/pagination',
            getUsageDetails: boServer + '/openapi-customer360/usage/detail',
            downloadUsageDetails: boServer + '/openapi-customer360/usage/download',
            getRankingApiCall: boServer + '/openapi-customer360/ranking-api-call',
            getAccountBalance: boServer + '/openapi-customer360/account-balance',
            getPrepaidCategories: boServer + '/openapi-customer360/prepaid',
            getFixedQuotaCombos: boServer + '/openapi-customer360/fixed-quota',
        },
        accountDataAnalysis: {
            postAccountDataAnalysisReport: boServer + '/user-data-analysis/report',
            postAccountDataAnalysisUserUsageSummary: boServer + '/user-data-analysis/user-usage-summary',
            postAccountDataAnalysisUserUsageDownload: boServer + '/user-data-analysis/user-usage-download',
            postAccountDataAnalysisUserSummary: boServer + '/user-data-analysis/user-summary',
        },
        companyReport: {
            getUserStats: boServer + '/company-rpt/company/user-stats',
            getCompanyAccountReport: boServer + '/company-rpt/account/${account_id}/${chart_id}',
        },
        companyXiaoshouyi: {
            postSyncById: boServer + '/company-xiaoshouyi/companies/${company_id}/sync',
            getXiaoshouyiId: boServer + '/company-xiaoshouyi/company/${companyName}',
        },
        dataResources: {
            getProductDataResources: boServer + '/data-resources/product/${product_id}',
            getRoleDataResources: boServer + '/role-data-resources/role/${role_id}',
            getCurrentUserDataResource: boServer + '/accounts/current-user-data-resource',
        },
        misc: {
            getInit: boServer + '/init',
            postCommonRegion: boServer + '/init/common-region/${region}',
            getOrderVolumeStats: boServer + '/order-volume/stats/${company_id}',
            postOrderVolumeBatch: boServer + '/order-volume/batch-add',
            getSystemCodes: boServer + '/systemcode/types/${type}/codes',
            postSalesforceSynchronize: boServer + '/salesforce-synchronize/${company_id}/all',
            getCompanyInfoByTyc: boServer + '/searchapi/tyc/companies',
            postChargeModeCompute: boServer + '/companies/${company_id}/charge-mode/compute',
        },
        export: {
            getExportCompany: boServer + '/behavior-export/company',
            getExportCompanies: boServer + '/behavior-export/companies',
            getExportUsers: boServer + '/behavior-export/users',
        },
        history: {
            getHistoryList: boServer + '/logauditrecords/${company_id}',
        },
        resource: {
            getProductResourceList: boServer + '/resources/product/${product_id}',
            // #region Resource
            getResourceList: boServer + '/capacity-resources/pagination',
            getResourceCustomizedList: boServer + '/capacity-resources/customized',
            postResourceCreate: boServer + '/capacity-resources/resource',
            putResourceEdit: boServer + '/capacity-resources/resource',
            // #endregion
            // #region Service
            getService: boServer + '/services/${service_id}',
            getServiceList: boServer + '/services/pagination',
            postServiceCreate: boServer + '/services/service',
            putServiceEdit: boServer + '/services/service',
            putServicePriceEdit: boServer + '/services/service/attributes',
            postServiceClone: boServer + '/services/service/clone',
            getServiceResourceLimitationsList: boServer + '/services/service/resource-limitations',
            postServiceResourceLimitationsCreate: boServer + '/services/service/resource-limitations',
            putServiceResourceLimitationsEdit: boServer + '/services/service/resource-limitations',
            putServiceResourceLimitationsDelete: boServer + '/services/service/resource-limitations',
            postServicePerformanceLimitationsCreate: boServer + '/services/service/resource-limitations',
            putServicePerformanceLimitationsEdit: boServer + '/services/service/resource-limitations',
            putServicePerformanceLimitationsDelete: boServer + '/services/service/resource-limitations',
            // #endregion
            // #region Capacity
            getCapacityList: boServer + '/capacities/pagination',
            postCapacityCreate: boServer + '/capacities',
            putCapacityEdit: boServer + '/capacities/capacity',
            getCapacityResouceByFeature: boServer + '/capacity-resources/feature-role/capacity-resources',
        },
        capacityDetail: {
            getAccountCapacity: boServer + '/tenant-user-capacity/capacity',
            getCompanyCapacity: boServer + '/company-capacity/${company_id}',
        },
        // #region SystemSAML
        systemSaml: {
            updateOrAddSaml: boServer + '/saml/config',
            deleteSamlById: boServer + '/saml/config/${id}',
            getSamlQuery: boServer + '/saml/config/pagination',
        },
        // #endregion
        // #region 搜索引擎管理
        searchEngineManagement: {
            getCompaniesSolr: boServer + '/companies/solr/companies',
            setCompaniesIndex: boServer + '/companies/index',
            createCompaniesIndex: boServer + '/companies/solr/index',
            deleteCompaniesIndex: boServer + '/companies/elastic-search/${id}',
            setCompaniesReindex: boServer + '/companies/reindex',
            getEmailSolr: boServer + '/accounts/email',
            createAccountsIndex: boServer + '/accounts/solr/index',
            delAccountsIndex: boServer + '/accounts/elastic-search/${id}',
            setAccountsIndex: boServer + '/accounts/index',
            setAccountsReindex: boServer + '/accounts/reindex',
            postCompanyUsersIndex: boServer + '/companies/${companyId}/users/reindex',
            postPackagesIndex: boServer + '/packages/index',
            deletePackagesIndex: boServer + '/packages/index',
            postPackagesReindex: boServer + '/packages/reindex',
            postGroupsIndex: boServer + '/groups/index',
            deleteGroupsIndex: boServer + '/groups/index',
            postGroupsReindex: boServer + '/groups/reindex',
            postGroupsMembersIndex: boServer + '/groups/members/index',
            deleteGroupsMembersIndex: boServer + '/groups/members/index',
            postGroupsMembersReindex: boServer + '/groups/members/reindex',
            setHistoryIndex: boServer + '/logauditrecords/index',
            createHistoryIndex: boServer + '/logauditrecords/elasticsearch/index',
            setHistoryReindex: boServer + '/logauditrecords/reindex',
        },
        // #endregion
        // #region SysTematic
        system: {
            getSqlList: boServer + '/sql',
            getKickoutrecords: boServer + '/kickoutauditrecords/pagination',
        },
        // #endRegion
        // #region: messageSend
        messageSend: {
            getMessageList: boServer + '/messages',
        },
        // #endRegion
        // #region 通知中心
        noticeCenter: {
            postNotificationScenesPagination: boServer + '/notification-scenes/pagination',
            postNotificationScenes: boServer + '/notification-scenes',
            putNotificationScenes: boServer + '/notification-scenes',
            getNotificationScenes: boServer + '/notification-scenes/scene/${id}',
            postNotificationUserMessagePagination: boServer + '/notification-user-message/pagination',
            getNotificationSceneTypes: boServer + '/notification-scene-types',
            postNotificationSceneTypes: boServer + '/notification-scene-types',
            putNotificationSceneTypes: boServer + '/notification-scene-types',
        },
        // #region Mail Manage
        mail: {
            get_mail_send_list: `${boServer}/mails`,
            postMailResend: `${boServer}/mails/ali/resend`,
            get_mail_receipts_list: `${boServer}/mail/receipts`,
            get_mail_status: boServer + '/mails/${id}',
            get_mailunreachables: `${boServer}/mail-unreachable`,
            delete_mailunreachable: boServer + '/mail-unreachable/${id}',
            patch_mailunreachable: boServer + '/mail-unreachable/${id}',
            postMailUnreachable: `${boServer}/mail-unreachable`,
            get_mail_config_list: `${boServer}/mail-config/pagination`,
            sync_mail_config: `${boServer}/mail-config`,
            get_mail_type_list: `${boServer}/mail-type/list`,
            get_mail_label_list: `${boServer}/mail-config/label`,
            sync_mail_type: `${boServer}/mail-type`,
            sync_mail_unsub_reason: `${boServer}/mail-reason`,
            mail_unsub_reason_list: `${boServer}/mail-reason/list`,
            user_mail_config: `${boServer}/mail-config-user/user`,
            sync_user_mail_config: `${boServer}/mail-config-user`,
            tenant_mail_config: `${boServer}/mail-config-company/tenant`,
            sync_tenant_mail_config: `${boServer}/mail-config-company`,
            getMailConfigReasonMailConfig: `${boServer}/mail-config-reason/mail-config`,
            postMailReasonBatch: `${boServer}/mail-reason/batch`,
            postMailTypeBatch: `${boServer}/mail-type/batch`,
            getMailConfigProduct: `${boServer}/mail-config/product`
        },
        // #endregion
        cacheManagement: {
            redis_namespaces: `${boServer}/redis/namespaces`,
            redis_keys_value: `${boServer}/redis/keys/value`,
            update_topic: `${boServer}/redis/publishment/resource/updated-topic`,
            synchronization_resource_info_redis: `${boServer}/redis/synchronization/soi/resource`,
            synchronization_resource_redis_type: boServer + '/redis/synchronization/${path}',
            synchronization_notify_identity: `${boServer}/redis/publishment/resource/updated-topic`,
        },
        // #region 自注册管理后台
        ApplyTrial: {
            // 查询安全限制的明细信息
            getSafeDetail: `${boServer}/self-register/safe`,
            // 更新当个ip注册上限
            putIpLimitation: `${boServer}/self-register/ip/limitation`,
            // 更新自注册的通知上限
            putNoticeLimitation: `${boServer}/self-register/notice/limitation`,
            // #region 自注册图表分析
            getActivityPromotionPagination: `${boServer}/activity-promotion/pagination`,
            getActivityPromotion: boServer + '/activity-promotion/${id}',
            postActivityPromotion: boServer + '/activity-promotion',
            putActivityPromotion: boServer + '/activity-promotion',
            postActivityPromotionBackground: boServer + '/activity-promotion/${id}/upload',
            patchActivityPromotionEnabled: boServer + '/activity-promotion/${id}/enabled/${enabled}',
            getActivityPromotionProductPackageKey: boServer + '/activity-promotion/product/package-key',
            postSyncCampaigns: `${boServer}/campaigns/sync`,
        },
        // #endregion
        // #region 用户行为相关
        Behavior: {
            getEmailsTree: `${boServer}/behavior/emailsTree`,
            postCustomerLoginList: boServer + '/companies/enterprise/type',
            postPrivilegeConcurrencyList: boServer + '/behavior/privilege-concurrency',
        },
        // #regin postman
        Postman: {
            postPostman: `${boServer}/postman`,
        },
        // #endregion,
        // #region 发版计划
        ReleasePlain: {
            getReleasePlanList: boServer + '/release-plan',
            getReleasePlanDetail: boServer + '/release-plan/${id}',
            postReleasePlanAdd: boServer + '/release-plan',
            putReleasePlanUpdate: boServer + '/release-plan',
            patchReleasePlanSwitchEnabled: boServer + '/release-plan',
        },
        // #endregion
        admin: {
            postEditBatchRoles: `${boServer}/accountroles/batch/patsnap`,
            getPatsnapAccountList: `${boServer}/accounts/patsnap`,
            getHistoryList: `${boServer}/log-audit-account-role`,
            postAccountsPatsnap: `${boServer}/accounts/patsnap`,
            getAuditLog: `${boServer}/logauditrecords/log-audit/operator-pagination`,
            postAccountReseller: `${boServer}/accounts/patsnap/reseller`,
            // 组织管理相关接口
            getDepartmentList: `${boServer}/bei-sen/department`,
            postDepartment: `${boServer}/bei-sen/department`,
            putDepartment: `${boServer}/bei-sen/department`,
            deleteDepartment: boServer + '/bei-sen/department/${id}',
            getEmployeeList: `${boServer}/bei-sen/employee`,
            postEmployee: `${boServer}/bei-sen/employee`,
            putEmployee: `${boServer}/bei-sen/employee`,
            deleteEmployee: boServer + '/bei-sen/employee/${id}',
            // CORS白名单相关接口
            getCorsWhitelist: `${boServer}/cors/whitelist`,
            updateCorsWhitelist: `${boServer}/cors/whitelist/update`,
            // SSO redirect_uri白名单相关接口
            getSsoRedirectWhitelist: `${boServer}/sso/redirect/whitelist`,
            updateSsoRedirectWhitelist: `${boServer}/sso/redirect/whitelist/update`,
        },
        SessionManagement: {
            getAccountsSessions: `${boServer}/session/accounts/sessions`,
            getCompanySessions: boServer + '/session/companies/${id}/sessions',
            deleteKickEmailSessions: `${boServer}/session/accounts`,
        },
        IllegalManagement: {
            // 查询违规IP列表
            getCarsiSuspectSellIPList: `${boServer}/carsi-suspect-sell/black-ip/pagination`,
            // 新增违规IP
            postAddCarsiSuspectSellIP: `${boServer}/carsi-suspect-sell/black-ip`,
            // 删除违规IP
            deleteCarsiSuspectSellIP: boServer + '/carsi-suspect-sell/black-ip/${ip}',
            // 查询违规公司列表
            getCarsiSuspectSellTenantList: `${boServer}/carsi-suspect-sell/tenant/pagination`,
            // 新增违规公司
            postAddCarsiSuspectSellTenant: `${boServer}/carsi-suspect-sell/tenant`,
            // 删除违规公司
            deleteCarsiSuspectSellTenant: boServer + '/carsi-suspect-sell/tenant/${tenant_id}',
            // 查询违规账号列表
            getCarsiSuspectSellUserList: `${boServer}/carsi-suspect-sell/user/pagination`,
            // 删除违规账号
            deleteCarsiSuspectSellUser: boServer + '/carsi-suspect-sell/user/${tenant_user_id}',
            // 编辑违规公司
            editCarsiSuspectSellTenant: boServer + '/carsi-suspect-sell/tenant-config/save',
        },
        OperationCenter: {
            getProductLine: `${boServer}/product-line`,
            postProductLine: `${boServer}/product-line`,
            deleteProductLine: boServer + '/product-line/${product_line_id}',
            getResourceSpaceList: boServer + '/resource-space/${product_line_id}/list',
            postResourceSpace: boServer + '/resource-space',
            putResourceSpace: boServer + '/resource-space',
            getResourceSpace: boServer + '/resource-space/${resource_space_id}',
            deleteResourceSpace: boServer + '/resource-space/${resource_space_id}',
            getResourceSpaceContentPagination: boServer + '/resource-space-content/pagination',
            postResourceSpaceContent: boServer + '/resource-space-content',
            putResourceSpaceContent: boServer + '/resource-space-content',
            postResourceSpaceContentClone: boServer + '/resource-space-content/clone/${resource_space_content_id}',
            getResourceSpaceContentOnShelvesCheck: boServer + '/resource-space-content/${resource_space_content_id}/on-shelves-check',
            postResourceSpaceContentOnShelves: boServer + '/resource-space-content/${resource_space_content_id}/on-shelves',
            getResourceSpaceContentOffShelvesCheck: boServer + '/resource-space-content/${resource_space_content_id}/off-shelves-check',
            postResourceSpaceContentOffShelves: boServer + '/resource-space-content/${resource_space_content_id}/off-shelves',
            getResourceSpaceContentDetail: boServer + '/resource-space-content/${content_id}/detail',
            getResourceSpaceContentDetailHistory: boServer + '/resource-space-content/${resource_space_content_id}/space-relation-histories',
            deleteResourceSpaceContent: boServer + '/resource-space-content/${resource_space_content_id}',
        },
        PromptManagement: {
            addPrompt: boServer + '/prompt',
            updatePrompt: boServer + '/prompt/${id}',
            deletePrompt: boServer + '/prompt/${id}',
            listPromptPagination: boServer + '/prompt/list',
            getPrompt: boServer + '/prompt/${id}',
            publishPrompt: boServer + '/prompt/release',
            keyGen: boServer + '/prompt/generate-key',
        },
        EmailTemplateManagement: {
            addTemplate: boServer + '/email-template',
            updateBasicInfo: boServer + '/email-template/${id}/base-info',
            updateContentTemplate: boServer + '/email-template/${id}/content',
            updateContentMock: boServer + '/email-template/${id}/mock-data',
            updateContentI18n: boServer + '/email-template/${id}/i18n',
            deleteTemplate: boServer + '/email-template/${id}',
            listPagination: boServer + '/email-template/list',
            getTemplate: boServer + '/email-template/${id}',
            publishTemplate: boServer + '/email-template/release',
            sendMail: boServer + '/email-template/test-send',
            preview: boServer + '/proxy/email-renderer/template-preview',
        },
        GlobalView: {
            // 获取GlobalView的公司列表
            getGlobalViewCompanyList: boServer + '/customer-view/global-view/pagination',
            // 获取GlobalView页面字段设置
            getGlobalViewFields: boServer + '/user-define-config/${configKey}',
            // 更新GlobalView页面字段设置
            putGlobalViewFields: boServer + '/user-define-config/save-or-update',
            // 获取GlobalView更新时间
            getGlobalViewUpdateTime: boServer + '/customer-view/global-view/earliest-run-success-date',
        },
        PqlRuleManagement: {
            // 获取PQL规则管理数据
            getPqlRuleManagementList: boServer + '/rule-center/rule-managements',
            // 获取PQL规则详情
            getPQLRuleDetail: boServer + '/rule-center/rule/${ruleId}',
            // 获取PQL指标列表
            getPQLRuleFilterFieldProperty: boServer + '/rule-center/field-properties',
            // 新建PQL规则
            addPQLRule: boServer + '/rule-center/rule',
            // 编辑PQL规则状态
            editPQLRuleStatus: boServer + '/rule-center/rule/${ruleId}/status',
            // 编辑PQL规则
            editPQLRule: boServer + '/rule-center/rule',
            // 校验PQL规则名称是否重复
            checkPQLRuleName: boServer + '/rule-center/rule/name-existence',
            // 预跑规则
            preRunRule: boServer + '/rule-center/rule/pre-execution',
            // 删除PQL规则
            deletePQLRule: boServer + '/rule-center/rule/${ruleId}',
            // 获取PQL数据分析数据
            getPqLRuleDataAnalysisList: boServer + '/rule-center/rule-data-analyzes'
        }
    };
}
